module.exports = __webpack_public_path__ + "img/4.16e96bcf.jpg";